import { styled } from '@mui/material';

export const StyledCheckboxWrapper = styled('div')(() => ({
  display: 'flex',
  flexdirection: 'row',
  justifyContent: 'flex-start',
  alignItems: 'center',
}));
